export default __webpack_public_path__ + "static/media/slider1.b2911cd2.jpg";